import React from 'react'

function Testing() {
  return (
    <div style={{width:'100%'}}>
      Testing
      <div className="" style={{width:'500px',height:'300px',borderBottom:'1px solid black'}}></div>
      <div className="" style={{width:'500px',height:'300px',borderBottom:'1px solid black'}}></div>
      <div className="" style={{width:'500px',height:'300px',borderBottom:'1px solid black'}}></div>
    </div>
  )
}

export default Testing
